import { useState, useEffect } from 'react';

export interface MarketIndexData {
  symbol: string;
  name: string;
  nameId: string;
  close: number;
  previousClose: number;
  change: number;
  changePercent: number;
  open: number;
  high: number;
  low: number;
  volume: number;
  timestamp: string;
}

export function useMarketIndices() {
  const [data, setData] = useState<MarketIndexData[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchIndices = async () => {
      try {
        const res = await fetch(`${import.meta.env.VITE_API_URL}/api/market/indices`);
        const json = await res.json() as { success: boolean; data?: MarketIndexData[] };
        if (!cancelled && json.success && json.data) setData(json.data);
      } catch {
        // silent
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchIndices();
    const interval = setInterval(fetchIndices, 60_000);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  return { data, loading };
}
